import { FC } from 'react'

const Icon: FC<{ color?: string }> = ({ color = '#3B42A5' }) => {
  return (
    <svg
      width='97'
      height='96'
      viewBox='0 0 97 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48.8652 3.00195C24.0261 3.00195 3.86523 23.1628 3.86523 48.002C3.86523 72.8411 24.0261 93.002 48.8652 93.002C73.7044 93.002 93.8652 72.8411 93.8652 48.002C93.8652 23.1628 73.7044 3.00195 48.8652 3.00195ZM0.865234 48.002C0.865234 21.506 22.3692 0.00195312 48.8652 0.00195312C75.3612 0.00195312 96.8652 21.506 96.8652 48.002C96.8652 74.498 75.3612 96.002 48.8652 96.002C22.3692 96.002 0.865234 74.498 0.865234 48.002Z'
        fill={color}
      />
      <path
        d='M45 26.002C45 23.7928 46.7909 22.002 49 22.002C51.2091 22.002 53 23.7928 53 26.002V54.002C53 56.2111 51.2091 58.002 49 58.002C46.7909 58.002 45 56.2111 45 54.002V26.002Z'
        fill={color}
      />
      <path
        d='M44.5 68.502C44.5 66.0167 46.5147 64.002 49 64.002C51.4853 64.002 53.5 66.0167 53.5 68.502C53.5 70.9872 51.4853 73.002 49 73.002C46.5147 73.002 44.5 70.9872 44.5 68.502Z'
        fill={color}
      />
    </svg>
  )
}

export default Icon
